import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditTeacher from '../../components/teachers/FormAddEditTeacher';
import { useParams } from 'react-router-dom';
import { useGetTeacher } from '../../hooks/teachers/useGetTeacher';
import LoadingPage from '../../components/global/LoadingPage';

const EditTeacher = () => {
    const { id } = useParams();
    const { teacher, isLoading } = useGetTeacher(id);
    if (isLoading) return <LoadingPage />;
    return (<WrapperSection><GlobalBreadcrumbs /><FormAddEditTeacher isEdit currentData={teacher?.data} /></WrapperSection>);
};
export default EditTeacher;
